import { ErrorHandler, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AppComponent } from './app.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { provideSvgIcons } from '@ngneat/svg-icon'
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin'
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin'
import { NgxsModule } from '@ngxs/store'
import { commonIcons, socialIcons } from '@lla-platform/icons'
import { CoreUiModule } from '@lla-platform/core/core-ui'
import { ToastrModule } from 'ngx-toastr'
import { environment, GlobalErrorHandler } from '@lla-platform/core/core-util'
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http'
import { BookmarksState, UserAccountState } from '@lla-platform/users/users-data-access'
import { AppRoutingModule } from './app-routing.module'
import { AuthLayoutModule } from './layout/auth-layout/auth-layout.module'
import { MainLayoutModule } from './layout/main-layout/main-layout.module'
import { AuthInterceptor, CoreFeatureModule } from '@lla-platform/core/core-feature'
import { MatDialogModule } from '@angular/material/dialog'
import {
  ArInvoicesState,
  ArPaymentsState,
  ReceivableState
} from '@lla-platform/receivable/receivable-data-access'
import { FiltersState } from '@lla-platform/core/core-data-access'
import { CustomersState } from '@lla-platform/customers/customers-data-access'
import {
  AdminViewTargetsState,
  PeriodTargetState,
  WeeklyTargetState
} from '@lla-platform/targets/targets-data-access'
import { ReviewsState } from '@lla-platform/reviews/reviews-data-access'
import { TimeagoModule } from 'ngx-timeago'
import { ReportsState } from '@lla-platform/reports/reports-data-access'
import { PaymentsState } from '@lla-platform/payments/payments-data-access'
import { ShopsState } from '@lla-platform/shops/shops-data-access'
import {
  AdminState,
  SalariesSummaryState,
  SalariesDetailState
} from '@lla-platform/admin/admin-data-access'
import { PromotionsState } from '@lla-platform/promotions/promotions-data-access'
import { TiresState, UsafState } from '@lla-platform/tires/tires-data-access'
import { TrackerState } from '@lla-platform/tracker/tracker-data-access'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTableModule } from '@angular/material/table'
import { ServiceCategoriesState } from 'service-categories-data-access'
import { SurveyState } from 'survey-data-access'
import { PublicLayoutModule } from './layout/public-layout/public-layout.module'
import { PageState } from 'page-data-access'
import { WorkOrdersState } from 'work-orders-data-access'
import { StockableState } from 'stockable-data-access'
import { AttendanceState } from 'attendance-data-access'
import { EventsCalendarState } from 'events-calendar-data-access'
import { DashboardState } from 'dashboard-data-access'
import { EmployeeState } from 'employee-data-access'
import { TechnicianState } from 'technician-data-access'
import { SchedulerState } from 'scheduler-data-access'
import { FluidsState } from 'fluids-data-access'
import { AddonsState } from '@lla-platform/addons/addons-data-access'
import { AnnouncementsState } from '@lla-platform/announcements/announcements-data-access'
import { FormState } from 'form-data-access'
import { withNgxsResetPlugin } from 'ngxs-reset-plugin'
import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import { CallIntelligenceState } from 'call-intelligence-data-access'

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatDialogModule,
    NgxsModule.forRoot(
      [
        UserAccountState,
        ReceivableState,
        FiltersState,
        CustomersState,
        ArInvoicesState,
        BookmarksState,
        WeeklyTargetState,
        PeriodTargetState,
        AdminViewTargetsState,
        ArPaymentsState,
        ReviewsState,
        ReportsState,
        PaymentsState,
        ShopsState,
        AdminState,
        PromotionsState,
        TiresState,
        UsafState,
        ServiceCategoriesState,
        TrackerState,
        SurveyState,
        PageState,
        WorkOrdersState,
        StockableState,
        AttendanceState,
        EventsCalendarState,
        DashboardState,
        EmployeeState,
        TechnicianState,
        SchedulerState,
        FluidsState,
        AddonsState,
        AnnouncementsState,
        FormState,
        SalariesSummaryState,
        SalariesDetailState,
        CallIntelligenceState
      ],
      {
        developmentMode: !environment.production
      }
    ),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
    NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
    ToastrModule.forRoot({
      timeOut: 6000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true
    }),
    CoreUiModule,
    MainLayoutModule,
    PublicLayoutModule,
    AuthLayoutModule,
    CoreFeatureModule,
    TimeagoModule.forRoot(),
    MatProgressSpinnerModule,
    MatTableModule
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    withNgxsResetPlugin(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideCharts(withDefaultRegisterables()),
    provideSvgIcons([...commonIcons, ...socialIcons])
  ]
})
export class AppModule {}
